import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-period-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent
  ],
  templateUrl: './period-form.component.html',
  styleUrl: './period-form.component.scss'
})
export class PeriodFormComponent implements OnChanges, OnInit {
  @Input() item: any = {};
  @Input() modalInstance: any = null;

  modalTitle: string = 'Periode toevoegen';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnChanges(changes: any) {
    this.loading = true;
    this.item = {};

    this.errorMessage = {};
    this.errors = {};
    this.getItem();
  }

  ngOnInit(): void {
    if (this.item['start_date']) {
      this.item['start_date'] = this.item['start_date'].replace(" 00:00:00", "");
    }

    if (this.item['end_date']) {
      this.item['end_date'] = this.item['end_date'].replace(" 00:00:00", "");
    }
  }

  afterSave() {
    this.activeModal.close(true);
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    this.item['start_date'] = this.item['start_date'].replace(" 00:00:00", "");
    this.item['end_date'] = this.item['end_date'].replace(" 00:00:00", "");

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let method: string = 'put';
    if (!this.item['id'] || this.item['id'] === '') {
      return this.apiService.post('/office/periods', this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/periods/' + this.item['id'], this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    self.afterSave();
    setTimeout(function () {
      self.loading = false;
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getItem() {
    let itemId = this.item['id'];
    let self = this;

    self.reset();
    if (itemId === '') {
      return;
    }
    return this.apiService.get('/office/periods/' + itemId).then(function (response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig periode';
      } else {
        self.modalTitle = 'Periode toevoegen';
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
